import Widget from "@/components/widgets";
import type { WidgetConfig } from "@/types";
import { HorizontalMarqeeGalleryComponentWidget } from "@/features/testimonial-gallery/components/horizontalMarquee";

declare global {
  interface Window {
    HorizontalMarqueeGalleryWidget: typeof HorizontalMarqueeGalleryWidget;
  }
}

class HorizontalMarqueeGalleryWidget extends Widget {
  static init(config: WidgetConfig) {
    return super.init(config, HorizontalMarqeeGalleryComponentWidget);
  }
}

if (typeof window !== "undefined") {
  window.HorizontalMarqueeGalleryWidget = HorizontalMarqueeGalleryWidget;
}

export default HorizontalMarqueeGalleryWidget;
